import * as angular from "angular";
import * as moment from "moment";

import "./notes.scss";

import { CurrentUserService } from "@services/currentUser.service";
import { IUserAction } from "../models/IUserAction";

class NotesController implements angular.IComponentController {

    noteTextToAdd: string;

    notes: IUserAction[];
    disabled: boolean;
    mandatoryReason: string;
    onNoteAdded: (args: { noteAdded: IUserAction }) => void;

    static $inject = ["currentUserService"];

    constructor(
        private readonly currentUserService: CurrentUserService) {
    }

    addNote() {

        this.currentUserService.getCurrentUser().then(user => {
            const newNote: IUserAction = {
                Comment: this.noteTextToAdd,
                UserId: user.Id,
                ActionDate: moment().toDate(),
                user: user
            };

            if (this.onNoteAdded) {
                this.onNoteAdded({ noteAdded: newNote });
            }

            this.noteTextToAdd = "";
        });
    }
}

export class NotesComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            notes: "<",
            disabled: "<?",
            mandatoryReason: "<?",
            onNoteAdded: "&"
        };

        this.controller = NotesController;
        this.template = require("./notes.html");
    }
}
